import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=2f15fa90&scoped=true&"
import script from "./Test.js?vue&type=script&lang=js&"
export * from "./Test.js?vue&type=script&lang=js&"
import style0 from "./Test.scss?vue&type=style&index=0&id=2f15fa90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15fa90",
  null
  
)

export default component.exports